import classNames from 'classnames';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Image } from '@udemy/react-core-components';
import { Meter } from '@udemy/react-messaging-components';
import { MediaObject } from '@udemy/react-structure-components';
import styles from "./compact-course-progress-card.module.css";
export const CompactCourseProgressCard = ({
  className,
  course
}) => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(MediaObject, {
    className: className
  }, /*#__PURE__*/React.createElement(MediaObject.ImageWrapper, null, /*#__PURE__*/React.createElement(Image, {
    src: course.image_240x135,
    className: styles['course-image'],
    alt: "",
    width: 240,
    height: 135
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['course-info']
  }, /*#__PURE__*/React.createElement(MediaObject.Title, {
    className: classNames('ud-heading-sm', styles['course-title'], {
      [styles['course-title-condensed']]: course.completion_ratio === 0
    }),
    "data-purpose": "course-title",
    href: `/course-dashboard-redirect/?course_id=${course.id}`
  }, course.title), !!course.completion_ratio && course.completion_ratio > 0 && /*#__PURE__*/React.createElement(Meter, {
    value: course.completion_ratio,
    min: 0,
    max: 100,
    label: gettext('%(percent)s% complete')
  }), course.completion_ratio === 0 && /*#__PURE__*/React.createElement("span", {
    className: classNames('ud-heading-sm', styles['start-learning'])
  }, gettext('Start learning'))));
};
//# sourceMappingURL=compact-course-progress-card.react-component.js.map